import type { ReferenceEntry } from "@/features/references/types";
import { PublicEmpty } from "@/pages/public/PublicState";
import { ReferenceCard } from "./ReferenceCard";

interface ReferenceGridProps {
  references: ReferenceEntry[];
}

export function ReferenceGrid({ references }: ReferenceGridProps) {
  if (references.length === 0) {
    return (
      <PublicEmpty
        title="No references found"
        description="Active testimonials will appear here once they are published in the CMS."
      />
    );
  }

  return (
    <div className="grid min-w-0 gap-5 lg:grid-cols-2">
      {references.map((reference) => (
        <ReferenceCard key={reference.id} reference={reference} />
      ))}
    </div>
  );
}
